import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { cn } from '../lib/utils';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const currentLang = i18n.language;

  const switchLanguage = (lang: string) => {
    // Update i18n language
    i18n.changeLanguage(lang);

    // Update URL path
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/^\/[a-z]{2}/, `/${lang}`);
    navigate(newPath);

    // Save preference to localStorage
    localStorage.setItem('preferred-language', lang);
  };

  return (
    <div className="flex items-center gap-1 bg-white/10 backdrop-blur-sm p-1 border border-white/10">
      <button
        onClick={() => switchLanguage('de')}
        className={cn(
          "px-3 py-1 text-xs font-bold transition-all duration-300",
          currentLang === 'de'
            ? "bg-white text-slate-900 shadow-sm"
            : "text-slate-300 hover:text-white hover:bg-white/10"
        )}
        aria-label="Switch to German"
        aria-current={currentLang === 'de' ? 'true' : 'false'}
      >
        DE
      </button>
      <button
        onClick={() => switchLanguage('en')}
        className={cn(
          "px-3 py-1 text-xs font-bold transition-all duration-300",
          currentLang === 'en'
            ? "bg-white text-slate-900 shadow-sm"
            : "text-slate-300 hover:text-white hover:bg-white/10"
        )}
        aria-label="Switch to English"
        aria-current={currentLang === 'en' ? 'true' : 'false'}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
